import React from 'react';
import Catalog from './pages/Catalog';
import Header from './layouts/Header';
import Footer from './layouts/Footer';
import { Routes, Route, Link } from 'react-router-dom';
import DeliveryAndPayment from './pages/DeliveryAndPayment';
import About from './pages/About';
import Contacts from './pages/Contacts';
import Item from './models/item';
import JeansDetails from './pages/JeansDetails';
import getItems from './services/item-service';
import Order from './pages/Order';
import PageTitle from './components/PageTitle';
import NotFound from './pages/NotFound';
import SizesTable from './pages/articles/SizesTable';
import Measurements from './pages/articles/Measurements';
import OriginalityСheck from './pages/articles/OriginalityСheck';
import ModelCatalog from './pages/ModelCatalog';

type AppProps = {
};
type AppState = {
  error: string | null;
  isLoaded: boolean;
  items: Array<Item>;
};

class App extends React.Component<AppProps, AppState> {
  constructor(props: AppProps) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      items: []
    };

    // Trigger loading items to state, but do not await here to not block rendering
    this.loadItems();
  }

  async loadItems() {
    getItems().then(
      (items) => {
        this.setState({
          isLoaded: true,
          items: items
        });
      },
      // Note: it's important to handle errors here
      // instead of a catch() block so that we don't swallow
      // exceptions from actual bugs in components.
      (error) => {
        this.setState({
          isLoaded: true,
          error
        });
      }
    )
  }

  render() {
    const { error, isLoaded, items } = this.state;

    return (
      <>
        <Header />
        <main id="main" className="container">
          {
            error ? <div className="m-5">Нажаль виникла помилка, будь-ласка, спробуйте пізніше.</div> :
            !isLoaded
              ? <div className="d-flex justify-content-center align-items-center vh-100">
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Завантажуємо...</span>
                  </div>
                </div>
              : <Routes>
                  <Route path="/" element={<Catalog items={items} />} />
                  <Route path="/m/levis-:model/" element={<ModelCatalog items={items} />} />
                  <Route path="/p/:slug/" element={<JeansDetails items={items} />} />
                  <Route path="/order/" element={<Order items={items} />} />

                  <Route path="/delivery-and-payment/" element={<DeliveryAndPayment />} />
                  <Route path="/about/" element={<About />} />
                  <Route path="/contacts/" element={<Contacts />} />

                  <Route path="/tablytsia-rozmiriv-levis/" element={<SizesTable items={items}/>} />
                  <Route path="/yak-robyty-zamiry-dzhyns-levis/" element={<Measurements items={items}/>} />
                  <Route path="/yak-pereviryty-oryhinalnist-dzhynsiv-levis/" element={<OriginalityСheck items={items}/>} />

                  <Route path="*" element={<NotFound />} />
                </Routes>
          }
        </main>
        <Footer />
      </>
    );
  }
}

export default App;

